/*
 * @Author: your name
 * @Date: 2021-06-02 14:11:31
 * @LastEditTime: 2021-08-02 09:50:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kapollo_media\src\assets\script\superClone.js
 */
function superClone(original) {
  let cloneObject = null;
  // if (original instanceof Function) {
  //   return original;
  // }
  if (typeof original !== "object" || original === null || original instanceof Function) {
    return original;
  }
  if (original instanceof Object) {
    cloneObject = {};
  }
  if (original instanceof Array) {
    cloneObject = [];
  }
  for (let key in original) {
    if (typeof original[key] === "object") {
      if (original[key] instanceof Object) {
        cloneObject[key] = superClone(original[key]);
      }
      if (original[key] instanceof Array) {
        cloneObject[key] = superClone(original[key]);
      }
      if (original[key] instanceof Function) {
        cloneObject[key] = original[key];
      }
      if (original[key] instanceof Date) {
        cloneObject[key] = original[key];
      }
    } else {
      cloneObject[key] = original[key];
    }
  }
  return cloneObject
}

export default superClone